<template>
  <div class="grid_item" v-if="isShow" :class="isActive" @click="scroll('partiChart')">
    <div class="item title">{{displayLabel}}</div>
    <div class="item status" :style="styleStatusAvg" v-if="isAvg">
      <div :class="displayStatusAvg">{{displayAvg}}</div>
    </div>
    <div class="item status" :style="styleStatus" v-else>
      <div :class="displayStatus">{{displayRate}}</div>
    </div>
    <div class="item text">
      <p>{{displayTotal}}</p>
      <p>{{displayDone}}</p>
    </div>
  </div>
</template>
<script>
import UT from "@/common/util";
import { STUDY_ITEMS } from "@/common/define";

export default {
  name: "cardGrid",
  props: {
    isAvg: Boolean,
    label: String,
    total: Number,
    todo: Number,
    done: Number,
    avg: Number,
    usercnt: Number
  },
  data() {
    return {
      dataColor: [
        'rgba(61,91,150,0.5)',
        'rgba(248,121,121,0.5)'
      ]
    }
  },
  methods: {
    scroll(id){
      document.getElementById(id).scrollIntoView({
        behavior: "smooth"
      });
    }
  },
  computed: {
    isShow() {
      return this.total > 0;
    },
    isActive() {
      return this.total > 0 ? "active" : "";
    },
    setLabel() {
      return this.label;
    },
    displayLabel() {
      return this.$i18n.translate(STUDY_ITEMS[this.label]);
    },
    displayTotal() {
      let text = this.$i18n.translate('전체');
      let total = this.total;
      if(this.isAvg){
          text = this.$i18n.translate('전체건수');
          total = this.total * this.usercnt;
      }
      total = UT.formatCurrency(total, 0);
      return `${text} : ${total}`;
    },
    displayDone() {
      let text = "";
      switch (this.label) {
        case "vod":
        case "choiceanswer":
        case "vpl":
        case "feedback":
        case "zoom":
          text = this.$i18n.translate("완료");
          if(this.isAvg){
            text = this.$i18n.translate("완료건수");
          }
          break;
        case "assignment":
        case "quiz":
        case "peerreview":
          text = this.$i18n.translate("제출");
          if(this.isAvg){
            text = this.$i18n.translate("제출건수");
          }
          break;
        case "url":
        case "courseboard":
        case "content":
        case "folder":
          text = this.$i18n.translate("참여");
          if(this.isAvg){
            text = this.$i18n.translate("참여건수");
          }
          break;
        default:
          text = "";
          break;
      }
      let done = UT.formatCurrency(this.done, 0);
      return `${text} : ${done}`;
    },
    displayAvg() {
      //let text = "";
      switch (this.label) {
        case "vod":
        case "choiceanswer":
        case "vpl":
        case "feedback":
        case "zoom":
          //text = this.$i18n.translate("학습율");
          break;
        case "assignment":
        case "quiz":
        case "peerreview":
          //text = this.$i18n.translate("제출율");
          break;
        case "url":
        case "courseboard":
        case "content":
        case "folder":
          //text = this.$i18n.translate("참여율");
          break;
        default:
          //text = "";
          break;
      }
      if (!this.total) {
        // return `${text} : 0%`;
        return '0%';
      }
      // return `${text} : ${UT.toFixed(this.avg / this.total * 100, 2)}%`;
      return  `${UT.toFixed(this.avg / this.total * 100, 2)}%`;
    },
    displayStatusAvg() {
      if (!this.total) {
        return "smile";
      }
      return this.isAvg && (this.avg / this.total * 100) >= 50 ? "smile" : "crying";
    },
    displayStatus() {
      if (!this.total) {
        return "smile";
      }
      return (this.done / this.total * 100) >= 50 ? "smile" : "crying";
    },
    displayRate() {
      return `${UT.toFixed(this.done / this.total * 100, 2)} %`;
    },
    styleStatusAvg() {
      let rate = 0;
      if (this.isAvg) {
        rate = this.avg / this.total * 100;
      } else {
        rate = this.done / this.total * 100;
      }
      // if (rate > 0) {
      //   return `background: linear-gradient(${this.dataColor[0]} ${rate}%, ${this.dataColor[1]})`;
      // } else {
      //   return `background: linear-gradient(${this.dataColor[1]} ${rate}%, ${this.dataColor[1]})`;
      // }
      if (rate > 50) {
        return `background: ${this.dataColor[0]}`;
      } else {
        return `background: ${this.dataColor[1]}`;
      }
    },
    styleStatus() {
      let rate = 0;
      if (this.isAvg) {
        rate = this.avg / this.total * 100;
      } else {
        rate = this.done / this.total * 100;
      }
      // if (rate > 0) {
      //   return `background: linear-gradient(${this.dataColor[0]} ${rate}%, ${this.dataColor[1]})`;
      // } else {
      //   return `background: linear-gradient(${this.dataColor[1]} ${rate}%, ${this.dataColor[1]})`;
      // }
      if (rate == 100) {
        return `background: ${this.dataColor[0]}`;
      } else {
        return `background: ${this.dataColor[1]}`;
      }
    }
  }
}
</script>

<style scoped>

</style>
